<template>
  <div class="home">
    <div class="search">
      <div class="block">
        <span>车牌</span>
        <div class="plate">
          <el-input
            placeholder="请输入要查询的车牌号"
            v-model="plate"
          ></el-input>
        </div>
        <span>选择查询时间</span>
        <el-date-picker
          v-model="date"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          :clearable="false"
        >
        </el-date-picker>
        <el-button type="primary" @click="submit" icon="el-icon-search"
          >查询</el-button
        >
        <el-button type="primary" @click="educe" icon="el-icon-download"
          >导出优惠明细</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      empty-text="暂无数据"
      max-height="72vh"
      v-loading="loading"
      element-loading-text="正在导出文件，请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
    >
      <el-table-column prop="plate" label="车牌号"> </el-table-column>
      <el-table-column prop="createTime" label="使用时间"> </el-table-column>
      <el-table-column prop="value" label="停车券额"> </el-table-column>
      <el-table-column prop="inTime" label="入场时间"> </el-table-column>
      <el-table-column prop="outTime" label="出场时间"> </el-table-column>
      <el-table-column prop="price" label="单价（元）"> </el-table-column>
      <el-table-column prop="needCharge" label="应收总额"> </el-table-column>
      <el-table-column prop="discountCharge" label="减免金额"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 30, 60, 80, 100]"
        :page-size="limit"
        layout="sizes, prev, pager, next"
        :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global";

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近1小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              var start = date.setHours(0, 0, 0, 0);
              var end = date.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const oDate = new Date();
              var year = oDate.getFullYear();
              var month = oDate.getMonth() + 1;
              var start, end;
              if (month == 0) {
                year--;
                start = new Date(year, 11, 1);
                end = new Date(year, 11, 31);
              } else {
                start = new Date(year, month - 1, 1);
                end = new Date(year, month, 0);
              }
              end.setTime(end.setHours(23, 59, 59, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              const oDate = new Date();
              var year = oDate.getFullYear();
              var month = oDate.getMonth();
              var start, end;
              if (month == 0) {
                year--;
                start = new Date(year, 11, 1);
                end = new Date(year, 11, 31);
              } else {
                start = new Date(year, month - 1, 1);
                end = new Date(year, month, 0);
              }
              end.setTime(end.setHours(23, 59, 59, 0));
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      date: [new Date().setHours(0, 0, 0, 0), new Date()],
      tableData: [],
      page: 1,
      limit: 10,
      count: 0,
      shopId: 56,
      plate: "",
      loading: false,
      // 需要导出的处理后的内容
      excelData: "",
      header: [
        "所属停车场",
        "车牌",
        "商家名称",
        "类型",
        "券额度",
        "入场时间",
        "出场时间",
        "单价(元)",
        "应收金额",
        "减免金额",
        "操作时间",
        "操作员",
        "备注",
      ],
      filter: [
        "parkId",
        "plate",
        "shopId",
        "type",
        "value",
        "inTime",
        "outTime",
        "price",
        "needCharge",
        "discountCharge",
        "createTime",
        "userName",
        "remark",
      ],
    };
  },
  mounted() {
    this.shopId = JSON.parse(sessionStorage.getItem("shopData")).shop.id;
    this.submit();
  },
  methods: {
    educe() {
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          var data = {
            // 商家ID
            shopId: this.shopId,
            // 开始时间
            timeStart: this.dates(new Date(this.date[0])),
            // 结束时间
            timeEnd: this.dates(new Date(this.date[1])),
            plate: this.plate,
          };
          util.derive(data, this.count).then((list) => {
            this.excelData = util.dwanLoad(list, this.filter); //导出的数据list。
            this.export2Excel();
          });
        })
        .catch(() => {});
    },

    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("../excel/Export2Excel.js"); //必须使用绝对路径
        const tHeader = that.header; // 标题
        const filterVal = that.filter; // 导出的字段名
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `excel`);
      });
    },

    formatJson(filterVal, jsonData) {
      this.loading = false;
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    submit() {
      if (
        util.judge(
          this.dates(new Date(this.date[0])),
          this.dates(new Date(this.date[1]))
        ) > 31
      ) {
        util.hint(400, "最大查询日期不能超过31天");
        return false;
      }
      let data = {
        // 商家ID
        shopId: this.shopId,
        // 开始时间
        timeStart: this.dates(new Date(this.date[0])),
        // 结束时间
        timeEnd: this.dates(new Date(this.date[1])),
        // 请求数据参数
        page: this.page,
        limit: this.limit,
        plate: this.plate,
      };
      this.$axios
        .post("/getOrderList", data)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            for (let i = 0; i < data.length; i++) {
              if (data[i].remark != "" && data[i].remark != null) {
                if (data[i].remark.indexOf("{") != -1) {
                  data[i].remark = "";
                }
              }
              switch (data[i].unit) {
                case 1:
                  data[i].value = data[i].value + "小时";
                  break;
                case 2:
                  data[i].value = data[i].value + "分钟";
                  break;
                case 3:
                  data[i].value = data[i].value + "天";
                  break;
                case 4:
                  data[i].value = data[i].value + "元";
                  break;
                case 5:
                  data[i].value = data[i].value + "折";
                  break;
                case 10:
                  data[i].value = "特定收费券";
                  break;
                case 999:
                  data[i].value = "全免";
                  break;
                default:
                  break;
              }
            }
            if (data.length == 0) {
              util.hint(2, "暂无数据");
            }
            this.tableData = data;
            this.count = res.count;
          } else {
            util.hint(res.code, res.msg);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    dates(date) {
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },

    // 当每页显示的数据条数发发生改变时（pageSize），触发此方法
    handleSizeChange(pageSize) {
      this.limit = pageSize;
      this.submit();
    },
    // 当前页面显示的页码发生改变时（pageIndex），触发此方法
    // 用户点击页码或者上一页 下一页的按钮时，都会使pageIndex发生改变
    handleCurrentChange(pageIndex) {
      this.page = pageIndex;
      this.submit();
    },

    status(data) {
      var list = data;
      for (let i = 0; i < list.length; i++) {
        switch (list[i].unit) {
          case 1:
            list[i].value = list[i].value + "小时券";
            break;
          case 2:
            list[i].value = list[i].value + "分钟券";
            break;
          case 3:
            list[i].value = list[i].value + "天券";
            break;
          case 4:
            list[i].value = list[i].value + "元券";
            break;
          case 5:
            list[i].value = list[i].value + "折券";
            break;
          default:
            list[i].value = "全免券";
            break;
        }
      }
      return list;
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0.1rem;
  box-sizing: border-box;

  .el-table {
    border: 1px solid #ebeef5;
    overflow-y: scroll;

    /deep/ th {
      padding: 0;
      height: 50px;
      line-height: 50px;
    }
  }

  .block {
    height: 1rem;
    padding: 0.2rem;
    box-sizing: border-box;
    text-align: left;
    line-height: normal;

    .plate {
      display: inline-block;
      .el-input {
        width: 100%;
      }
    }
    span {
      display: inline-block;
      height: 0.4rem;
      line-height: 0.4rem;
      vertical-align: middle;
      padding: 3px 10px;
      font-size: 0.2rem;
    }
  }

  .paging {
    text-align: center;
    padding: 0.2rem;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shopDetail.vue